export const COMMS_PREFERENCE_OPTIONS = [
  { id: 'P'.charCodeAt(0), label: 'Do not phone' },
  { id: 'E'.charCodeAt(0), label: 'Do not email' },
  { id: 'M'.charCodeAt(0), label: 'Do not mail' },
  { id: 'S'.charCodeAt(0), label: 'Do not sms' },
  { id: 'B'.charCodeAt(0), label: 'No bulk emails (user opt out)' },
];
